/**
 * Links into the Products plugin, built from its mounted root path. Every id
 * is encoded here, so an id with a space or "/" stays one path segment.
 */
const segments = (path: string) =>
  path.split('/').filter(Boolean).map(encodeURIComponent);
const withSearch = (path: string, search?: string | URLSearchParams) => {
  const query = search?.toString().replace(/^\?/, '');
  return query ? `${path}?${query}` : path;
};

export function productPaths(root: string) {
  const base = root.replace(/\/+$/, '');
  const product = (
    id: string,
    tab = 'overview',
    search?: string | URLSearchParams,
  ) =>
    withSearch(
      [base, encodeURIComponent(id), ...segments(tab)].join('/'),
      search,
    );
  return {
    /** The directory, optionally with its view and filter query. */
    directory: (search?: string | URLSearchParams) =>
      withSearch(base || '/', search),
    /** A product tab; `tab` is a fixed path such as "technical/software". */
    product,
    offering: (id: string, offeringId: string) =>
      `${product(id, 'offerings')}/${encodeURIComponent(offeringId)}`,
    software: (id: string, softwareId: string) =>
      `${product(id, 'software')}/${encodeURIComponent(softwareId)}`,
  };
}
export type ProductPaths = ReturnType<typeof productPaths>;
